const keyPressed = (keyList, keys, prevKeys) => {
  if (!prevKeys || !keys) {
    return false;
  }
  return keyList.some((key) => keys.get(key) === true && keys.get(key) !== prevKeys.get(key));
};
const keyDown = (keyList, keys) => {
  if (!keys) {
    return false;
  }
  return keyList.some((key) => keys.get(key) === true);
};
export {
  keyDown,
  keyPressed
};
//# sourceMappingURL=keys.js.map
